import React, { Component } from 'react'
import { Layout, PageHeader, Button, Icon, Input } from 'antd'
import { observer, inject } from 'mobx-react'
import { companies, policies } from '@services/api'
import { withRouter } from 'react-router-dom'
import CompaniesList from './CompaniesList'
import CompanyPopup from '@components/Popup/CompanyPopup'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
@withRouter
export default class Insurance extends Component<any, any> {
    state = {
        companiesList: [],
        filtered: [],
        loading: true
    }

    handleAddCompany = () => {
        this.props.popupStore.togglePopup('addCompany', {})
    }

    filterCompanies = value => {
        const { companiesList } = this.state

        const filtered = companiesList.filter(company => {
            return company.name.includes(value) || company.id.toString().includes(value)
        })

        this.setState(prevState => ({ ...prevState, filtered }))
    }

    componentDidMount() {
        this.updateCompanies()
    }

    updateCompanies = async () => {
        await companies
            .getList()
            .then(res => {
                const companiesList = res.data
                this.setState({ companiesList, loading: false })
                this.filterCompanies('')
            })
            .catch(e => {
                console.log(e)
            })
    }

    filterByID = e => {
        this.state.policyIdError && this.setState({ policyIdError: false })
        e.keyCode == 13 &&
            policies
                .getPoliciesById(e.target.value)
                .then(res => {
                    const { company_id, id } = res.data[0]
                    this.props.history.push(`/insurance/${company_id}/${id}`)
                })
                .catch(e => alert('לא נמצאה פוליסה'))
    }

    render() {
        const { filtered, companiesList } = this.state
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="רשימת חברות הביטוח"
                    subTitle={
                        filtered < companiesList
                            ? `מציג ${filtered.length} חברות מתוך ${companiesList.length}`
                            : `סה"כ ${companiesList.length} חברות`
                    }
                >
                    <Button style={{ fontSize: '1rem' }} onClick={this.handleAddCompany}>
                        <Icon type="plus" /> הוסף חברת ביטוח
                    </Button>
                    <Input.Search
                        placeholder="חיפוש על פי שם חברה או מזהה"
                        onChange={e => this.filterCompanies(e.target.value)}
                        style={{ width: '40%', marginRight: '0.5rem' }}
                    />
                    <Input.Search
                        placeholder={'חיפוש על פי מזהה פוליסה'}
                        onKeyDown={e => this.filterByID(e)}
                        style={{ width: '40%', marginRight: '0.5rem' }}
                    />
                </PageHeader>
                <CompaniesList list={filtered} loading={this.state.loading} />
                <CompanyPopup popupUpdated={() => this.updateCompanies()} />
            </Layout>
        )
    }
}
